import { CartProductsActivation } from "../cart/components/cart";

export default function LoadWishLists() {
  $.getJSON("/api/CustomersWishlist", function (data) {
    $("#tab3 .profile-product-group").remove();
    if (data.length) {
      var template = $.templates('#wishListsTemplate');
      var outerHtml = template.render({ Wishlists: data });
      $(outerHtml).insertAfter(".wishlist-info");
      CartProductsActivation();
      $("#myWishlistsCounter").html(" (" + data.length + ")");
    }
  });
}